import { render, staticRenderFns } from "./ocrimport.vue?vue&type=template&id=9f0e2ebc&scoped=true&"
import script from "./ocrimport.vue?vue&type=script&lang=js&"
export * from "./ocrimport.vue?vue&type=script&lang=js&"
import style0 from "./ocrimport.vue?vue&type=style&index=0&id=9f0e2ebc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0e2ebc",
  null
  
)

export default component.exports